import React from "react";
import logo from "assets/images//tomujin_academy.svg";
import miniLogo from "assets/images/favicon.ico";
import { NavLink } from "react-router-dom";

function Header() {
  return (
    <>
      <div
        className={
          "fixed inset-x-0 h-[60px] bg-primary2 top-0 flex justify-between px-7 gap-2 items-center py-2 z-50 transition-all"
        }
      >
        <NavLink to={"/"}>
          <img src={logo} style={{ height: 40 }} className="hidden md:block" />
          <img
            src={miniLogo}
            style={{ height: 40 }}
            className="block md:hidden"
          />
        </NavLink>
        <div className="md:text-2xl font-bold text-[#5c1090]">
          {/* Томүжин Академийн зуны сургууль */}
        </div>
        <div className="hidden md:block"></div>
      </div>
    </>
  );
}

export default Header;
